import AntdConfigProvider from 'antd/es/config-provider';
import { ComponentProps, useState } from 'react';
import { useMount } from 'ahooks';
import type { Locale } from 'antd/es/locale';
import dayjs from 'dayjs';
import { localeMap, defaultLocale } from '../locale/navigate';
import type { SupportLocale } from '../locale/navigate';

type Props = ComponentProps<typeof AntdConfigProvider> & DefaultLocaleType;
type DefaultLocaleType = { defaultLocale?: SupportLocale };

/**
 *
 * @desc 懒加载 Antd 国际化
 * @param props
 * @returns
 */
function DynamicConfigProvider(props: Props) {
    const [loading, setLoading] = useState(true);

    const [locale, setLocal] = useState<Locale | undefined>(undefined);

    useMount(async () => {
        const localeCode = props.defaultLocale || defaultLocale;

        import(`@/library/locale/${localeCode}.ts`)
            .then((remoteLocale: { default: Locale }) => {
                // console.log('defaultLocale ===', localeCode, remoteLocale);
                // 设置 Antd locale 环境
                setLocal(remoteLocale.default);
                // 设置 dayjs locale 环境
                dayjs.locale(localeMap[localeCode] || 'en');

                setLoading(false);
            })
            .catch((error) => {
                console.warn(`ef-ui: 找不到${props.defaultLocale}对应的语言，采用默认语言：en_US`);
            });
    });

    if (loading) return <></>;

    return <AntdConfigProvider locale={locale} {...props} />;
}

export default DynamicConfigProvider;
